<template>
  <div class="page_ BJQ_">
    <div class="header">
      <p class="text_">本产品由史带财产保险股份有限公司承保</p>
    </div>
    <a-row class="padd_20">
      <a-col>
        <div class="s_flex_">
          <div class="form_label">保险期限</div>
          <div>1年</div>
        </div>
      </a-col>
      <a-col>
        <div class="s_flex_">
          <label class="form_label">客户名称</label>
          <a-input
            v-if="!show"
            class="form_wid"
            v-model="formInfo.userName"
            placeholder="请输入客户名称"
          ></a-input>
          <span v-else>{{ formInfo.userName }}</span>
        </div>
      </a-col>
    </a-row>

    <!-- 投保方案循环 -->
    <div v-for="(occu, index) in occuList" :key="'occu' + index">
      <!-- 一个方案开始 -->
      <!-- 计划类别 -->
      <a-row class="main_con" style="padding: 0px 20px">
        <a-col>
          <div v-if="!show" class="s_flex_">
            <div class="form_label">第{{ index + 1 }}个计划</div>
            <a-select
              @change="(v) => planChange(v, occu, index)"
              class="form_wid"
              v-model="occu.planCode"
            >
              <a-select-option
                v-for="item in quotationPlans"
                :value="item.planCode"
                :key="item.planCode"
              >
                {{ item.planName }}
              </a-select-option>
            </a-select>
            <a-button class="del_btn_" v-if="!show" @click="delFromOccu(index)">删除</a-button>
          </div>
          <div v-else class="s_flex_">
            <div class="form_label">第{{ index + 1 }}个计划</div>
            <div>{{ occu.planCode | filterPlan }}</div>
          </div>
        </a-col>

        <a-col>
          <div class="s_flex_">
            <div class="flex_1">职业类别</div>
            <div class="flex_1">高空职业</div>
          </div>
          <div>
            <div v-for="(item, index) in occu.levelList" :key="index">
              <div class="s_flex_">
                <div class="flex_1">
                  {{ item.level }}类：
                  <a-input-number
                    v-if="!show"
                    :min="0"
                    v-model="item.number"
                    style="width: 80px; margin-right: 10px"
                    @blur="levelListBlur"
                  >
                  </a-input-number>
                  <span v-else>{{ item.number?item.number:0 }}</span>
                  人
                </div>
                <div class="flex_1 flex_">
                  <a-select
                    v-if="!show"
                    v-model="item.isHighWork"
                    default-value="N"
                    @blur="(e)=>handleHighChange(e,item,occu)"
                    style="width: 60px"
                  >
                    <a-select-option value="N">否</a-select-option>
                    <a-select-option value="Y">是</a-select-option>
                  </a-select>
                  <span v-else>{{ item.isHighWork == "N" ? "否" : "是" }}</span>
                  <span>{{ item[item.itemType] || 0 }}元</span>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
      <!-- 主附险 -->
      <a-row class="main_con">
        <div class="block_ border_">
          <a-col>
            <div class="title_">
              <span>必选主险</span>
              <span>保险金额</span>
            </div>
            <div
              class="s_flex_"
              v-for="(item, index) in occu.renderMainRisk"
              :key="index"
            >
              <div class="form_label">{{ item.coverageName }}</div>
              <div>{{ item.selectCoverage / 10000 }}万元</div>
            </div>
          </a-col>
          <a-col>
            <div class="title_">
              <span>可选附加险</span>
              <span>保险金额</span>
            </div>
            <div>
              <div
                class="s_flex_"
                v-for="(item, index) in occu.renderAddiRisk"
                :key="index + 'addi'"
              >
                <label class="form_label">{{ item.coverageName }}</label>
                <a-select
                  v-model="occu.form[item.coverageCode]"
                  @change="(v)=>handleYHHBlur(v,item,index,occu)"
                  style="width: 100px"
                   v-if="!show"
                  class="form_wid"
                >
                  <a-select-option
                    v-for="ele in item.selectList"
                    :value="ele.insuredAmount"
                    :key="ele.planCode"
                  >
                    {{
                      ele.insuredAmount == 0 ? "不附加" : ele.insuredAmount
                    }}
                    </a-select-option
                  >
                </a-select>
                <span v-else>{{occu.form[item.coverageCode] || 0}}</span>
              </div>
            </div>
          </a-col>

          <div class="title_">
            <span>计划保费</span>
            <span>{{ occu.planPremium || 0 }}元</span>
          </div>
          <!-- <div class="title_">
            <span>单一事故赔偿限额</span>
            <span>{{ occu.limitMoney || 0 }}元</span>
          </div>
           -->
        </div>
      </a-row>
      <!-- 一个方案结束 -->
    </div>
    <div class="flex_ pd_t0">  
      <span style="font-weight:bold;">单一事故赔偿限额：{{allLimit|filterNumber}}元</span>
      <span style="font-weight:bold;">总保费：{{totalPremium}}元</span>
    </div>

    <div v-if="!show" class="flex_ btnList pd_t0">
      <a-button v-if="!show" @click="addMore()">增加新计划</a-button>
      <a-button @click="handleCalBtn()">计算保费</a-button>
      <!-- <a-button @click="validateHuman()">校验</a-button> -->
    </div>

    <Bottom :quotationData="quotationData" />

    <!-- <div v-if="!show" class="read">
      <a-checkbox @change="onChange" :checked="isCheck"
        ><span class="check">我已阅读并知晓产品须知及条款内容</span></a-checkbox
      >
    </div> -->

    <div v-if="!show" class="bottom_btn">
      <span @click="handleDisplay">转发报价</span>
    </div>
  </div>
</template>

<script>
import api from "@/utils/sdApi";
import option from "../option";
import common from "../common.js";
import Bottom from "../components/bottom";
let App = null;
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  components: {
    Bottom,
  },
  data() {
    return {
      maxLevel: 1,
      formInfo: {
        userName: "",
        planCode: "",
      },
      isCheck: true,
      quotationPlans: {
        quotationPlans: [],
      },
      levelList: [],
      quotationData: {},
      totalMan: 0,
      totalPremium: 0, //总保费
      calculObj: {},
      myData: option.myData,
      renderMainRisk: [], //处理后的主险列表
      renderAddiRisk: [], //处理后的附险列表
      // riskList: [], //所有险别表
      occuList: [
        {
          planCode: "plan1",
          levelList: [],
          form: {},
          totalMan: 0,
          limitMoney:0,//单一事故赔偿限额
          //每个方案主附险独立
          renderMainRisk: [], //处理后的主险列表
          renderAddiRisk: [], //处理后的附险列表
        },
      ], //多个方案列表，每个方案可独立选择计划和职业类别人数和主附险信息
      YHHPickPlanCode: 'NO_',//YHH可选的计划
      allLimit: 0,//单一事故赔偿限额-总
    };
  },
  beforeCreate() {
    App = this;
  },
  filters: {
    filterPlan(val) {
      let list = App.quotationData.quotationPlans;
      if (!list) {
        list = [];
      }
      let v = "";
      list.map((item) => {
        if (item.planCode == val) {
          v = item.planName;
        }
      });
      return v;
    },
    filterNumber(val){
      let value = val
      if(val > 10000){
        value = val/10000 + '万'
      }
      return value
    }
  },
  mounted() {
    const { id } = this.$route.query;
    const { show } = this.$route.params;

    if (id) {
      this.quoteId = id;
    }

    this.queryQuotationInfo()
      .then(() => {
        //计算器页面
        if (this.quotationData.quotationInfo.templateCode != "001") {
          this.initMethods();
        }
      })
      .then(() => {
        //报价显示页面(展示页)
        if (show) {
          this.quotationLinkData("Q", "", (res) => {
            let data = JSON.parse(res.data.msg);
            this.occuList = data.occuList;
            this.formInfo = data.formInfo;
            this.totalPremium = data.totalPremium;
            this.allLimit = data.allLimit
          });
        }
      });
  },
  methods: {
    ...common,
    addMore() {
      const len = this.occuList.length
        
      this.occuList.push({
        levelList: [],
        form: {
        },
        planCode: "plan1",
        totalMan: 0,
      });
      let planList = this.quotationData.quotationPlans;
      this.planChange(planList[0].planCode, this.occuList[0], len,'NO');
      console.log(this.occuList,"-->this.occuList")
    },
    delFromOccu(index){ //删除整个计划即方案
       this.occuList.splice(index,1)
       if(this.totalPremium){ //计算过才重新计算
        this.handleCalBtn()
       }
    },
    viewInfo() {
      console.log(this.occuList);
      console.log(this.formInfo);
    },
    onChange(e) {
      console.log(e.target);
      this.isCheck = e.target.checked;
    },
    handleHighChange(e,item,occu){
      console.log(item,occu)
      let list = this.quotationData.quotationCoverageList
      let planList = list.find(ele => {  //计划5下面的计划列表
        return ele.occupationLevel == 5   //根据5类职业判断是否存在当前计划，已跟后端确认
      }).list[0].planList
      let exit = planList.find(ele => {
        return ele.planCode == occu.planCode
      })
      console.log(planList,exit)
      if(!exit){
        //存在则说明该类别下含有当前选择计划
        this.$message.warning('该计划项下无法承保涉高人员，请重新选择计划')
        item.isHighWork = "N"
      }
    },
    levelListBlur(e) {
      this.totalMan = 0;
      this.occuList[0].levelList.map((item) => {
        if (item.number) {
          this.totalMan += parseInt(item.number);
        }
      });
    },
    concatParams() {
      let obj = {
        //保费计算参数
        items: [],
      };

      obj.items.push({
        itemCategory: "I",
        itemType: "PLAN_CODE",
        itemValue: this.formInfo.planCode,
      });

      this.occuList[0].levelList.map((item) => {  //险别代码一致，所以选择1类下面的险别
        if (item.number) {
          obj.items.push({
            itemCategory: "I",
            itemType: item.itemType,
            itemValue: item.number,
          });
        }
      });

      return obj;
    },

    queryQuotationInfo() {
      let data = {
        quoteId: this.quoteId,
        type: "Q",
      };
      return api.queryQuotationInfo(data).then((res) => {
        this.quotationData = res.data.msg;
        this.renderAllLevelList();
      });
    },
    renderAllLevelList() {
      //加载时先渲染所有occuList的类别表
      let arr = [];
      this.quotationData.quotationCoverageList.map((item) => {
        arr.push({
          level: item.occupationLevel,
          number: "",
          itemType: "occ_num_" + item.occupationLevel,
          isHighWork: "N", //是否涉高
        });
      });
      this.occuList[0].levelList = [...arr];
    },
    //团意模板start
    planChange(val, occu, index,resetOrNot) {
      this.reset(occu,resetOrNot)
      //计划改变
      console.log(val, "--->计划改变");
      this.levelControl(val, occu, index); //参数：所选计划code，返回：可显示的职业类别列表

      const list = this.formatCoverageList(val); //根据选择计划名称动态更新list
      // this.riskList = list;
      this.formatMainRisk(list, val, index);
      this.formatAddiRisk(list, val, index);

    },
    reset(occu,resetOrNot){ //重置数据,resetOrNot(string)是否重置
      console.log(occu)
      if(resetOrNot&&resetOrNot=='NO'){
        return
      }
      occu.form = {}
    },
    formatCoverageList(planCode) {
      //参数：计划code，返回：类别下（存在所选计划）的险别列表

      let coverageList = this.quotationData.quotationCoverageList; //职业类别list
      for (let i in coverageList) {
        let array = coverageList[i].list[0].planList;
        let exit = array.find((ele) => {
          return ele.planCode == planCode;
        });
        /**
         * exit：遍历险别列表，类别下（存在所选计划），就返回主附险列表
         */
        if (exit) {
          console.log(
            coverageList[i].list,
            "---->类别下（存在所选计划）的险别列表"
          );
          return coverageList[i].list;
        }
      }
    },
    levelControl(planCode, occu, index) {
      //参数：planCode-所选计划，occu当前投保方案，index-投保方案下标
      // 返回：可显示的职业类别列表
      /**
       * exit：遍历险别列表，类别下（存在所选计划），就返回组装类别list
       */
      let data = this.quotationData.quotationCoverageList;
      let arr = [];
      data.map((item) => {
        let list = item.list[0].planList;
        let exit = list.find((ele) => {
          return ele.planCode == planCode;
        });
        if (exit) {
          arr.push({
            level: item.occupationLevel,
            number: "",
            itemType: "occ_num_" + item.occupationLevel,
            isHighWork: "N", //是否涉高
          });
        }
      });

      this.occuList[index].levelList = [...arr];
    },
    initMethods() {
      //查询时默认带出一个投保方案
      let planList = this.quotationData.quotationPlans;
      this.quotationPlans = planList;

      this.planChange(planList[0].planCode, this.occuList[0], 0,"NO");
    },
    formatMainRisk(list, val, index) {
      //参数：险别列表，返回：需渲染主险列表
      console.log(list, "所有险别");

      //主险处理
      let mainList = list.filter((item) => {
        return item.riskType == 1;
      }); //主险列表
      console.log(mainList, "主险列表");

      let renderMainRisk = [];
      mainList.map((item) => {
        renderMainRisk.push({
          coverageName: item.coverageName,
          coverageCode: item.coverageCode,
          selectCoverage: this.findCoverage(item.planList, null, val), //选中计划的保额
        });
      });
      this.occuList[index].form[renderMainRisk[0].coverageCode] =
        renderMainRisk[0].selectCoverage;
      this.occuList[index].renderMainRisk = renderMainRisk;
      console.log(renderMainRisk, "主险渲染列表");
    },
    formatAddiRisk(list, planCode, index) {
      //参数：list险别列表，planCode选择计划，index方案下标
      //目的：组装当前方案附险下拉框（可选范围：保额小于方案下选择计划的保额）
      console.log(list, planCode, index, "当前方案计划change");

      //1.查找附险列表
      let additionList = list.filter((item) => {
        return item.riskType == 2;
      });

      let renderAddiRisk = [];
      additionList.map((item) => {
        //2.查找当前方案选择的计划的保额
        let coverage
        let exit = item.planList.find((item) => {
          return item.planCode == planCode;
        })
        if(exit) {
          coverage = exit.insuredAmount;
        }

        //3.组装附险数据及下拉选项
        renderAddiRisk.push({
          coverageName: item.coverageName,
          categoryType: item.categoryType,
          coverageCode: item.coverageCode,
          selectList: this.findAddiList(item.planList, coverage),
        });
      });
      this.occuList[index].renderAddiRisk = renderAddiRisk;
      console.log(renderAddiRisk, "附险渲染列表");
    },
    findAddiList(list, coverage) {
      //组装附险下拉
      let arr = list.filter((item) => {
        return item.insuredAmount&&item.insuredAmount <= coverage;
      });
      arr.unshift({
        insuredAmount: 0,
        planCode: "NO_",
      });
      return arr;
    },
    findCoverage(list, type, pCode) {
      //参数：列表，type：null或name，功能：从list查找key值
      //计划list中查询当前选中计划的保额
      let key = "insuredAmount";
      if (type && type == "name") {
        key = "planName";
      }

      let val = 0;
      let exit = list.find((item) => {
        return item.planCode == pCode;
      });
      if (exit) {
        val = exit[key];
      }
      return val;
    },
    handleYHHBlur(e,item,index,occu){
      console.log(e,item,index,occu)
      if(item.categoryType == 'YHH'){
        let exit = item.selectList.find(item=>{
          return item.insuredAmount == e
        })
        if(exit){
          this.YHHPickPlanCode = exit.planCode
        } else {
          console.log("不附加")
        }
        
        let YhhList = occu.renderAddiRisk.filter(ele=>{
          return ele.categoryType == "YHH"
        })
        YhhList.map(ele => {
          occu.form[ele.coverageCode] = this.getInsuredAmount(ele.selectList,this.YHHPickPlanCode)
        })

        console.log(occu.form)

        this.occuList = [...this.occuList]
      }
    },
    getInsuredAmount(list,planCode){
      let exit  = list.find(item => {
        return item.planCode == planCode
      })
      console.log(exit,"exit.insuredAmount")
      if(exit){
        return exit.insuredAmount
      } else {
        return 0
      }
    },
    quotationLinkData(type, string, callback) {
      let data = {};
      if (type == "S") {
        data = {
          flag: type,
          quoteId: this.quoteId,
          content: string,
          uStr: this.$route.query.uStr,
        };
      } else if (type == "Q") {
        data = {
          flag: "Q",
          linkId: this.$route.query.linkId,
        };
      }
      return api.quotationLinkData(data).then((res) => {
        callback(res);
      });
    },
    calculatePremium() {
      //保费计算
      let data = {
        quoteId: this.quoteId,
        planItems: this.getPlanItems(),
      };
      console.log(data, "计算参数");

      return api
        .calculatePremium(data)
        .then((res) => {
          console.log(res, "计算信息返回");
          this.setPremium(res.data.msg);
        })
        .catch(() => {
        });
    },
    setPremium(obj) {
      this.totalPremium = obj.totalPremium
      
      let list = this.occuList;
      list.map((item,index) => {
        console.log(obj, "计算返回数据",index);
        // let preObj = obj.planItems.find((ele) => {  //之前用planCode查询，但可能存在选择同一计划的情况
        //   return ele.planCode == item.planCode;
        // });
        let preObj = obj.planItems[index]
        if (preObj) {
          item.levelList.map((ele) => {
            ele[ele.itemType] = preObj[ele.itemType];
          });
        } else {
          console.log("不存在preObj");
        }
        item.planPremium = preObj.planPremium;
      });
      this.occuList = [...list];
      console.log(this.occuList);
    },
    getPlanItems() {
      //计算1：组装PlanItems
      let list = this.occuList;
      let arr = [];
      list.map((item) => {
        let obj = {
          planCode: item.planCode,
          items: this.getItems(item),
        };
        arr.push(obj);
      });
      return arr;
    },
    getItems(item) {
      //计算2：组装Items
      let arr = [];

      //计算2-1:职业类别参数
      const levelList = item.levelList;
      levelList.map((ele) => {
        arr.push({
          itemCategory: "I",
          itemType: ele.itemType,
          itemValue: ele.number,
          isHighWork: ele.isHighWork,
        });
      });

      //计算2-2:附险参数
      const renderAddiRisk = item.renderAddiRisk;
      renderAddiRisk.map((ele,index) => {
        let obj = {
          itemCategory: "C",
          itemType: ele.coverageCode,
          itemValue: item.form[ele.coverageCode],
          riskType: "2",
        }
        if(ele.categoryType == 'YHH'){
          obj.planCode = this.YHHPickPlanCode
        }
        arr.push(obj);
      });

      //计算2-3:主险参数
      const renderMainRisk = item.renderMainRisk;
      renderMainRisk.map((ele) => {
        arr.push({
          itemCategory: "C",

          itemType: ele.coverageCode,
          itemValue: ele.selectCoverage,
          riskType: "1",
        });
      });

      return arr;
    },
    validateHuman(){
      //保单人数校验
      //list 1.人数校验规则
      let list = this.quotationData.quotationItems.find(item=>{
        return item.itemType == 'INSURED_NUMS'
      })
      console.log(list,"===>list")
      
      //2.获得最大level
      let maxLevel = this.getMaxlevel() 
      this.maxLevel = maxLevel //记录maxLevel

      if(!list.premiumRules){
        console.log("输入值的职业类别没有配置校验规则")
        return true
      }

      //3.获取具体校验规则，即获取几类的校验规则
      let validateObj = list.premiumRules.find(item => {
        return item.occupationLevel.indexOf(maxLevel) > -1
      })
      console.log(validateObj,list,maxLevel)

      if(!validateObj){
        console.log("输入值的职业类别没有配置校验规则")
        return true
      }

      //4.分情况校验
      return this.validate(validateObj)
    },
    validate(obj){
      console.log(obj,"=====>555")
      let pass = true
      //最小值校验
      let result = this.findHumanNum(obj)
      switch(obj.dayMinUnit){ 
        case 'n':   //人数校验
          if(result.all<obj.dayMin){
            this.$message.warning(`${obj.dayMin}人起保`);
            pass = false
          }
        break;
        case 'p':  //占比校验
          if(result.single/result.all<obj.dayMin/100){
            this.$message.warning(`${obj.occupationLevel}类比例不得小于${obj.dayMin}%`);
            pass = false
          }
        break;
      }

      //最大值校验
      switch(obj.dayMaxUnit){
        case 'n':  //人数校验
          if(result.all>obj.dayMax){
            this.$message.warning(`最大投保人数不得超过${obj.dayMax}人`);
            pass = false
          }
        break;
        case 'p':   //占比校验
          if(result.single/result.all>obj.dayMax/100){
            this.$message.warning(`${obj.occupationLevel}类比例不得大于${obj.dayMax}%,1-4类涉高时按照5类计算`);
            pass = false
          }
        break;
      }
      return pass
    },
    //获取某些类别人数和所有人数
    findHumanNum(obj){
      let single = 0,all = 0,key = ["1","2","3","4"]
      let occuList = this.occuList
      console.log(occuList,"===>occuList")
      occuList.map(item => {
        item.levelList.map(ele => {
          if(ele.number){
            all += parseInt(ele.number)
            if(obj.occupationLevel.indexOf(ele.level)>-1){
              single +=  parseInt(ele.number)
            }
            if(this.maxLevel == 5&&ele.isHighWork == 'Y'&&key.includes(ele.level)){
              single +=  parseInt(ele.number)
            }
          }
        })
      })
      return {single,all}
    },
    getMaxlevel(){  //获取页面输入职业类别人数的最大职业类别值
      let maxLevel = 1
      let occuList = this.occuList
      let key = ["1","2","3","4"]

      console.log(occuList)

      //规则2
      occuList.map(item => {
        item.levelList.map(ele => {
          if(ele.number&&ele.level>maxLevel){
            maxLevel = ele.level
          }

          //查询1-4类职业是否选择了涉高
          if(key.indexOf(ele.level)>-1&&ele.isHighWork == 'Y'){
            maxLevel = 5
          }
        })
      })

      //规则4.1到4类职业选了涉高时按5类职业计算保费，同时也用5类职业的检验规则来检验人数
      return maxLevel
    },
    handleCalBtn() {
      let pass = this.validateHuman()
      if(pass){
        this.calculatePremium().then(()=>{
          this.calcLimitMoney()
        })
      }
    },
    calcLimitMoney(){ //计算单一赔偿限额
      //单一事故赔偿限额=(YXA1001+YXA1008-1)*人数/2，跟1000万两者取小
      let list = this.occuList
      console.log(list)
      let allLimit = 0
      list.map(item => {
        item.limitMoney = this.calcLimit(item)
        allLimit += parseFloat(item.limitMoney)
      })
      if(allLimit < 10000000){
        this.allLimit = allLimit
      } else {
        this.allLimit = 10000000
      }
      

    },
    calcLimit(item){
      //单一事故赔偿限额=(YXA1001+YXA1008-1)*人数/2，跟1000万两者取小
      //1.YXA1001
        let YXA1001 = item.form['YXA1001']
        let YXA1008_1 = item.form['YXA1008-1']
        if(!YXA1008_1){
          YXA1008_1 = 0
        }
        if(!YXA1001){
          YXA1001 = 0
        }
        let num = 0
        item.levelList.map(ele => {
          if(ele.number){
            num += parseInt(ele.number)
          }
        })
        let money = (YXA1001+YXA1008_1)*num/2
        return money
    },
    handleDisplay() {
      console.log(this.formInfo, "-->formInfo");
      let obj = {
        totalPremium: this.totalPremium,
        allLimit: this.allLimit,
        formInfo: this.formInfo,
        occuList: this.occuList,
      };
      let formString = JSON.stringify(obj);
      if (!this.isCheck) {
        this.$message.warning("请先阅读协议并勾选");
        return;
      }
      this.quotationLinkData("S", formString, (res) => {
        let origin = window.location.origin;
        window.location.href =
          window.location.origin +
          `/pcmall/BJQ/display/${true}?id=${this.quoteId}&linkId=${
            res.data.msg
          }`;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page_ {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 100px;
  .padd_20 {
    padding: 20px;
  }
  .text_ {
    padding: 15px 15px 0 15px;
    margin-bottom: 0;
  }
  .header {
    img {
      width: 100%;
      height: auto;
    }
  }
  .main_con {
    padding: 20px;
    margin: 0 auto;
    .block_ {
      padding: 10px;
      &.border_ {
        border: 1px solid #ccc;
        border-radius: 5px;
      }
    }
    .title_ {
      display: flex;
      margin: 10px 0;
      justify-content: space-between;
      span {
        // flex: 1;
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
  .tab_ {
    display: flex;
    width: 92%;
    margin: 0 auto;
    color: #007aff;
    span {
      flex: 1;
      padding: 10px;
      text-align: center;
      position: relative;
      &.on::after {
        position: absolute;
        content: "";
        display: block;
        width: 20px;
        height: 1px;
        background-color: #007aff;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
  }

  .read {
    margin-top: 20px;
    display: flex;
    padding-left: 20px;
    .check {
      color: #ff5600;
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    box-shadow: 2px 0 17px 2px rgba(154, 183, 198, 0.35);
    span {
      flex: 1;
      background-color: #fff;
      text-align: center;
      color: #333;
      padding: 20px 10px;
      // &:nth-child(2n) {
      background-color: #007aff;
      color: #fff;
      // }
    }
  }
}
.flex_ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.s_flex_ {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  margin: 10px 0;
  align-items: center;
  .flex_3 {
    flex: 3;
  }
  .flex_2 {
    flex: 2;
  }
  .flex_1 {
    flex: 1;
  }
  .del_btn_{
    margin-left: 5px;
  }
  .form_wid {
    width: 100%;
  }
  .form_label {
    width: 150px;
    margin-right: 20px;
  }
}
.btnList{
  padding: 0 20px;
}
.pd_t0{
  padding:0 20px 20px 20px;
}
.tips_ {
  font-size: 12px;
  margin: 5px 0;
}
.tips_1 {
  margin-bottom: 30px;
}
</style>
